/**
 * Single owner of how a JSON payload goes on the wire.
 *
 * A request with a JSON body must pair `Content-Type: application/json` with
 * a `JSON.stringify`-ed body. That pairing used to be re-spelled at every
 * call site, and it was only sometimes load-bearing: the authenticated path
 * in api.ts back-filled a missing header, but the `public: true` path did
 * not, so a public call that forgot the header silently went out as
 * text/plain. Now api.ts (all repository traffic) and auth.ts (the
 * token-refresh bootstrap, which api.ts depends on and which therefore
 * cannot call back into api.ts) both build their JSON requests here, and
 * `jsonRequestOwnership.test.ts` fails CI if the pairing reappears anywhere
 * else.
 */
export function jsonRequestInit(method: string, payload: unknown): RequestInit {
  return {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  };
}
